import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { NgModule }     from '@angular/core';

import { DirectivesModule } from '../directives/directives.module';
import { FlipperComponent } from './flipper/flipper.component';
import { IconComponent }    from './icon/icon.component';
import { ImageViewModule }  from './image-viewer/image-viewer.module';
import { ListBoxComponent } from './list-box/list-box.component';

@NgModule({
  declarations: [
    FlipperComponent,
    IconComponent,
    ListBoxComponent
  ],
  entryComponents: [
    FlipperComponent,
    IconComponent,
    ListBoxComponent
  ],
  exports: [
    CommonModule,
    FormsModule,

    FlipperComponent,
    IconComponent,
    ImageViewModule,
    ListBoxComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Custom
    DirectivesModule,
    ImageViewModule
  ]
})
export class ComponentsModule {}
